import { viewModelEventReceived, viewModelStateUpdate } from './actions';
import { isOptions } from '../helpers';
import { useDispatch } from 'react-redux';
import { useViewModel } from '@resolve-js/react-hooks';
import { useCallback, useMemo, useRef } from 'react';
import { getEntry } from './view-model-reducer';
var defaultQueryOptions = {
  method: 'GET'
};
var defaultHookOptions = {};
var internalActions = {
  stateUpdate: viewModelStateUpdate,
  eventReceived: viewModelEventReceived
};
export function useReduxViewModel(query, options) {
  var actualOptions = isOptions(options) ? options : defaultHookOptions;
  var actualActionCreators = actualOptions.actions || internalActions;
  var stateUpdate = actualActionCreators.stateUpdate,
      eventReceived = actualActionCreators.eventReceived;
  var selectorId = actualOptions.selectorId;
  var name = query.name,
      aggregateIds = query.aggregateIds,
      args = query.args;
  var dispatch = useDispatch();
  var stateChangeCallback = useCallback(function (state, initial) {
    if (typeof stateUpdate === 'function' && !initial) {
      dispatch(stateUpdate(query, state, initial, selectorId));
    }
  }, []);
  var eventReceivedCallback = useCallback(function (event) {
    if (typeof eventReceived === 'function') {
      dispatch(eventReceived(query, event, selectorId));
    }
  }, []);

  var _useViewModel = useViewModel(name, aggregateIds, args, stateChangeCallback, eventReceivedCallback, actualOptions.queryOptions || defaultQueryOptions),
      connect = _useViewModel.connect,
      dispose = _useViewModel.dispose,
      initialState = _useViewModel.initialState;

  var initialStateDispatched = useRef(false);

  if (!initialStateDispatched.current) {
    if (typeof stateUpdate === 'function') {
      dispatch(stateUpdate(query, initialState, true, selectorId));
    }

    initialStateDispatched.current = true;
  }

  return useMemo(function () {
    return {
      connect: connect,
      dispose: dispose,
      selector: function selector(state) {
        return getEntry(state.viewModels, selectorId || {
          query: query
        });
      }
    };
  }, [connect, dispose]);
}
//# sourceMappingURL=use-redux-view-model.js.map